{
  "nl": {
    "schoolClass": {
      "actions": {
        "leave": "Klassenlokaal verlaten"
      },
      "activityViewer": {
        "createdAt": "{dateTime}",
        "createdAtTwelveHour": "{dateTime}",
        "breadcrumb": {
          "activities": "Activiteiten"
        },
        "navigation": {
          "previous": "Vorige activiteit",
          "next": "Volgende activiteit"
        },
        "export": {
          "document": "Document opslaan",
          "audio": "Audiobestand opslaan",
          "image": "Afbeelding opslaan"
        },
        "placeholder": {
          "unknownPupil": "Onbekend",
          "unknownWorksheet": "Onbekend werkblad"
        },
        "worksheet": {
          "submission": "Inlevering: {worksheetName}",
          "goToDetailView": "Naar detailweergave"
        },
        "pupilFeedback": {
          "submission": "Inlevering: {assignmentName}",
          "unknownAssignment": "Onbekende opdracht",
          "averageScore": "ø Waarde inlevering:",
          "feedbackLabel": "Feedback",
          "goToDetailView": "Naar detailweergave"
        },
        "error": {
          "loadingActivities": "Fout bij het laden van de activiteiten. Probeer het opnieuw.",
          "activityNotFound": "Activiteit niet gevonden."
        },
        "converter": {
          "additionalInfo": "Extra informatie en doelgroep",
          "source": "Bron",
          "result": "Resultaat",
          "noAudio": "Geen audiobestand beschikbaar",
          "noOutputText": "Geen uitvoertekst beschikbaar",
          "labels": {
            "text": "Resultaat",
            "transcript": "Transcript",
            "summary": "Samenvatting",
            "translation": "Vertaling",
            "audio": "Audio",
            "podcast": "Podcast",
            "lecture": "Lezing",
            "dialog": "Dialoog"
          }
        },
        "textEditor": {
          "untitled": "Naamloos document"
        },
        "pinboardCard": {
          "noContent": "Deze kaart heeft geen inhoud.",
          "goToCard": "Naar kaart"
        },
        "pinboardComment": {
          "noContent": "Deze reactie heeft geen inhoud.",
          "goToCard": "Naar kaart"
        },
        "pinboardList": {
          "description": "Deze lijst ordent kaarten op een prikbord en bevat zelf geen inhoud.",
          "goToBoard": "Naar prikbord"
        },
        "surveyResponse": {
          "anonymous": "Geen detailweergave beschikbaar — enquête-inzendingen zijn anoniem.",
          "goToResponses": "Naar resultatenoverzicht"
        },
        "wordEntry": {
          "wordCloudLabel": "in woordwolk:",
          "goToWordCloud": "Naar woordwolk"
        }
      },
      "activityContent": {
        "loading": "Inhoud wordt geladen...",
        "notSupported": "Voorbeeld nog niet beschikbaar",
        "comingSoon": "Deze toolvoorbeeld zal binnenkort beschikbaar zijn",
        "emptyState": "Geen inhoud beschikbaar",
        "errors": {
          "unauthorized": "Je hebt geen toestemming om deze inhoud te bekijken",
          "notFound": "Deze inhoud is niet meer beschikbaar",
          "loadFailed": "Inhoud kon niet worden geladen",
          "unexpected": "Er is een onverwachte fout opgetreden"
        },
        "chat": {
          "emptyState": "Geen berichten in dit gesprek"
        },
        "textEditor": {
          "emptyState": "Dit document is leeg"
        },
        "worksheet": {
          "noContent": "Geen inhoud om weer te geven"
        }
      },
      "activities": {
        "actions": {
          "downloadImage": "Afbeelding downloaden"
        },
        "labels": {
          "name": "Naam",
          "content": "Inhoud",
          "project": "Project",
          "access": "Toegang",
          "createdAt": "Aangemaakt op",
          "viewActivity": "Activiteit bekijken"
        },
        "itemTitles": {
          "pinboardCard": "Nieuwe kaart „{name}”",
          "pinboardList": "Nieuwe lijst „{name}”",
          "pinboardComment": "Nieuwe reactie op „{name}”",
          "surveyResponse": "Nieuwe inlevering „{name}”",
          "wordEntry": "Nieuw item „{name}”"
        },
        "saveConversation": "Gesprek opslaan",
        "saveDocument": "Document opslaan",
        "saveResponse": "Inlevering opslaan",
        "saveResult": "Resultaat opslaan",
        "sectionTitle": "Laatst aangemaakt",
        "projectSectionTitle": "Activiteiten in dit project",
        "projectSectionTooltip": "Klik op een activiteit om de details te openen. Inleveringen en AI-chatgeschiedenissen kun je downloaden via het 3-puntenmenu.",
        "emptyState": "Er zijn nog geen activiteiten. Zodra je aan een project werkt, kun je hier je activiteiten zien.",
        "projectEmptyState": "In dit project zijn nog geen activiteiten. Zodra je leerlingen aan het project werken, verschijnen hun activiteiten hier.",
        "filters": {
          "ariaLabel": "Activiteiten filteren",
          "title": "Activiteiten filteren",
          "all": "Alle",
          "access": {
            "title": "Toegang",
            "label": "Toegang selecteren…",
            "ariaLabel": "Filteren op toegang"
          },
          "content": {
            "title": "Inhoud",
            "label": "Inhoud"
          },
          "status": {
            "title": "Status",
            "label": "Status",
            "ariaLabel": "Filteren op status",
            "completed": "Afgerond",
            "open": "Open"
          },
          "timeframe": {
            "title": "Periode",
            "label": "Periode",
            "totalPeriod": "Gehele periode",
            "last7Days": "Laatste 7 dagen",
            "last30Days": "Laatste 30 dagen",
            "thisYear": "Dit jaar ({year})",
            "lastYear": "Vorig jaar ({year})",
            "customRange": "Periode instellen"
          }
        }
      },
      "activity": {
        "addPupil": "Toegang toevoegen",
        "downloadCodes": "Lijst weergeven"
      },
      "alert": {
        "discardedMembershipTitle": "Je bent geen actief lid meer van dit klassenlokaal",
        "discardedMembershipBody": "Al je projecten zijn beëindigd. Zonder actief lidmaatschap kun je geen nieuwe projecten aanmaken.",
        "discardedMembershipProjectBody": "Zonder actief lidmaatschap kun je dit project niet meer openen. Word opnieuw lid van het klassenlokaal om weer toegang te krijgen.",
        "sharedClassroomAccessItem1": "Leerlingen loggen in op <a href='https://go.fobizz.com' target='_blank'>go.fobizz.com</a>. Hier vind je alle toegangscodes, mocht een leerling de code kwijt zijn.",
        "sharedClassroomAccessItem2": "<strong>Let op</strong>: Alle docenten gebruiken dezelfde codes voor leerlingen van een gedeelde klasruimte. Zorg ervoor dat je <strong>wijzigingen</strong> in de lijst altijd <strong>afstemt</strong> met alle collega's die deze klasruimte delen.",
        "sharedClassroomAccessTitle": "Toegangsbeheer in gedeelde klasruimte"
      },
      "classroom": {
        "create": "Klasruimte aanmaken",
        "createDescription": "Deel werkopdrachten met je leerlingen en stel AI-tools en materialen beschikbaar voor de verwerking.",
        "links": {
          "new": "Klasruimte aanmaken",
          "back": "Terug",
          "discardedProjects": "Afgeronde projecten",
          "pausedProjectsTab": "Gepauzeerde projecten",
          "activeProjects": "Huidige projecten",
          "projects": "Projecten",
          "currentProject": "Project",
          "members": "Docenten",
          "accessCodes": "Toegangen"
        },
        "projectFilter": {
          "ariaLabel": "Projecten filteren op status",
          "all": "Alle",
          "active": "Actief",
          "paused": "Gepauzeerd",
          "ended": "Afgerond"
        },
        "info": {
          "classroom": {
            "heading": "Toegangen tot de klasruimte privacy-conform beheren",
            "listItems": "<ol><li>Lijst uitprinten en toewijzen: noteer op papier wie wie is.</li><li>Toegangscodes verdelen: één code per persoon per schooljaar.</li><li>Toegang krijgen: leerlingen loggen in op <a href='https://go.fobizz.com'>go.fobizz.com</a>.</li></ol>",
            "manage": "Beheren",
            "showAccessCodes": "Toegangscodes weergeven"
          },
          "index": {
            "body": "Met de klasruimtes werken leerlingen zelfstandig en veilig met digitale tools.<br>Je hebt de keuze uit twee varianten:",
            "heading": "Tools en AI voor je klas",
            "option1": "<strong class=\"fw-semibold\">Klasruimte voor 1 jaar</strong><br>Meerdere projecten, individuele toegangscode per leerling, samenwerking met andere docenten in dezelfde klasruimte, automatische verwijdering na 365 dagen",
            "option2": "<strong class=\"fw-semibold\">Klasruimte voor 24 uur</strong><br>Een enkel project, uniforme toegangslink voor iedereen, automatische verwijdering na 24 uur"
          }
        },
        "labels": {
          "activateControls": {
            "hours24": "24 uur",
            "hours24WithMaximum": "24 uur",
            "hours24Full": "24 uur",
            "oneMonthWithMaximum": "1 maand",
            "extend": "Verlengen",
            "reactivate": "Reactivatie",
            "stop": "Pauzeren"
          },
          "model": {
            "name": "Naam van de klasruimte",
            "namePlaceholder": "Naam invoeren...",
            "studentAccess": "Toegangen leerlingen"
          },
          "school": "School",
          "shareHint": "Je kunt de klasruimte na het aanmaken delen met collega's. De uitnodigingslink vind je in het gedeelte 'Docenten'.",
          "studentAccessTooltip": "Aantal leerlingen dat tegelijkertijd in deze klasruimte kan werken. Elke persoon ontvangt een individuele toegangscode."
        },
        "indexTitle": "Klasruimtes",
        "pageTitle": "Mijn klasruimtes",
        "pupil": {
          "loggedInAs": "Aangemeld als",
          "logout": "Afmelden"
        }
      },
      "confirmDialog": {
        "deletePupil": {
          "confirmButton": "Verwijderen",
          "text": "Deze actie kan niet ongedaan worden gemaakt. De toegangscode wordt verwijderd en kan niet meer worden gebruikt om in te loggen.",
          "title": "Toegang verwijderen?"
        },
        "deleteTemplate": {
          "confirmButton": "Verwijderen",
          "text": "Deze actie kan niet ongedaan worden gemaakt. De sjabloon wordt permanent verwijderd en is niet meer beschikbaar voor nieuwe projecten.",
          "title": "Projectsjabloon verwijderen?"
        },
        "discardProject": {
          "confirmButton": "Verwijderen",
          "text": "Deze actie kan niet ongedaan worden gemaakt. Het project wordt permanent verwijderd.",
          "title": "Project verwijderen?"
        },
        "finishProject": {
          "confirmButton": "Beëindigen",
          "text": "Het project wordt beëindigd en naar het archief verplaatst. Je vindt het daarna onder de gearchiveerde projecten van de klasruimte.",
          "title": "Project beëindigen?"
        },
        "leave": {
          "confirmButton": "Verlaten",
          "text": "Je hebt daarna geen toegang meer tot de klasruimte en de inhoud ervan.",
          "title": "Klasruimte verlaten?"
        },
        "saveAsTemplate": {
          "confirmButton": "Opslaan",
          "text": "Het project wordt als sjabloon opgeslagen en daarbij losgekoppeld van de klasruimte.",
          "title": "Project als sjabloon opslaan?"
        }
      },
      "download": {
        "abbreviation": "Afkorting",
        "accessCode": "Toegangscode",
        "accessCodesForClass": "Toegangscodes voor ",
        "accessCreationInstruction": "Op app.fobizz.com kun je in het overzicht van deze klasruimte eenvoudig verdere toegangen aanmaken.",
        "accessListForClass": "Toegangslijst voor",
        "documentNotice": "Dit document is alleen bestemd voor jouw administratie en moet vertrouwelijk worden behandeld. Deel nooit persoonlijke gegevens van je leerlingen online.",
        "goToInstruction": "Ga naar: ",
        "needMoreAccess": "Heb je meer toegangen nodig?",
        "note": "Notitie",
        "yourAbbreviation": "Jouw afkorting:",
        "yourAccessCode": "Jouw toegangscode: "
      },
      "errors": {
        "createFailed": "Project kon niet worden aangemaakt."
      },
      "flash": {
        "accessCodeCopied": "Toegangscode gekopieerd naar klembord",
        "createSuccess": "Project is succesvol aangemaakt.",
        "deactivatePupilFailure": "Toegang kon niet worden gedeactiveerd.",
        "deactivatePupilSuccess": "Toegang is succesvol gedeactiveerd.",
        "deactivateTeacherFailure": "Toegang van de docent kon niet worden gedeactiveerd.",
        "deactivateTeacherSuccess": "Toegang van de docent is succesvol gedeactiveerd.",
        "deletePupilFailure": "Toegang kon niet worden verwijderd.",
        "deletePupilSuccess": "Toegang is succesvol verwijderd.",
        "leaveFailure": "Fout bij het verlaten van de klasruimte.",
        "leaveSuccess": "Je hebt de klasruimte succesvol verlaten.",
        "finishProjectSuccess": "Project succesvol beëindigd.",
        "pauseProjectSuccess": "Project succesvol gepauzeerd.",
        "resumeProjectSuccess": "Project succesvol gereactiveerd.",
        "extendProjectSuccess": "Project succesvol verlengd.",
        "restoreProjectSuccess": "Project succesvol hersteld.",
        "shareProjectSuccess": "Je project is succesvol gedeeld.",
        "shareProjectFailure": "Het project kon niet worden gedeeld.",
        "privateItem": "De deeleinstellingen voor deze inhoud zijn bijgewerkt.",
        "reactivatePupilFailure": "Toegang kon niet worden gereactiveerd.",
        "reactivatePupilSuccess": "Toegang is succesvol gereactiveerd.",
        "reactivateTeacherFailure": "Toegang van de docent kon niet worden gereactiveerd.",
        "reactivateTeacherSuccess": "Toegang van de docent is succesvol gereactiveerd.",
        "regenerateTokenFailure": "Toegangscode kon niet opnieuw worden gegenereerd.",
        "regenerateTokenSuccess": "Toegangscode is succesvol opnieuw gegenereerd.",
        "remixedItem": "Deze AI-assistent is voor jou geremixt en naar je account gekopieerd.",
        "updateSchoolClassSuccess": "Klasruimte is succesvol bijgewerkt.",
        "copyError": "Fout bij het kopiëren naar het klembord.",
        "noAccessCode": "Geen toegangscode aanwezig.",
        "deleteFailed": "Project kon niet worden verwijderd.",
        "createFromTemplateFailed": "Project kon niet worden gemaakt op basis van de sjabloon.",
        "saveAsTemplateSuccess": "Project is succesvol opgeslagen als sjabloon.",
        "saveAsTemplateFailed": "Project kon niet worden opgeslagen als sjabloon.",
        "deleteTemplateSuccess": "Sjabloon is succesvol verwijderd.",
        "deleteTemplateFailed": "Sjabloon kon niet worden verwijderd.",
        "updateTemplateSuccess": "Projectsjabloon is bijgewerkt.",
        "updateTemplateFailed": "Projectsjabloon kon niet worden bijgewerkt."
      },
      "hints": {
        "aiChatAlert": "Met de AI-Chat kunnen leerlingen ook hun eigen AI-Assistenten maken.",
        "projectFiles": "Upload bestanden die jouw leerlingen in het project kunnen bekijken en downloaden.",
        "projectItems": "Deel maximaal 10 materialen/assistenten met leerlingen.",
        "projectTools": "Om privacy- en technische redenen kunnen momenteel alleen de opgegeven tools voor leerlingen worden vrijgegeven."
      },
      "labels": {
        "inactivePupil": "Toegang gedeactiveerd",
        "owner": "Admin",
        "pupilName": "Naam",
        "showQrCode": "QR-code weergeven",
        "activity": "Activiteit",
        "totalToolsCount": "Activiteit | Activiteiten",
        "createdAt": "Aangemaakt op"
      },
      "members": {
        "actions": {
          "discard": "Toegang deactiveren",
          "undiscard": "Toegang reactiveren"
        },
        "status": {
          "header": "Toegang",
          "active": "Toegang actief",
          "deactivated": "Toegang gedeactiveerd"
        },
        "empty": "Nog geen docenten toegevoegd",
        "schoolAccessExpired": {
          "title": "Uitnodigen niet mogelijk",
          "text": "Dit klaslokaal behoort tot de school „{companyName}”, waarvoor geen actieve licentie voor gedeelde klaslokalen meer bestaat. Collega's kunnen daarom niet meer worden uitgenodigd.",
          "textWithoutSchool": "Voor dit klaslokaal bestaat geen actieve licentie voor gedeelde klaslokalen meer. Collega's kunnen daarom niet meer worden uitgenodigd."
        },
        "invite": {
          "title": "Docenten uitnodigen voor de klasruimte",
          "titleShort": "Docenten uitnodigen",
          "tooltip": "Alleen klasruimte-toegang. Projecten niet inbegrepen.",
          "retry": "Uitnodigingslink genereren",
          "regenerate": "Opnieuw genereren",
          "showQrCode": "QR-code weergeven",
          "qrCodeTitle": "QR-code",
          "qrCodeAlt": "QR-code voor de uitnodigingslink",
          "confirmRegenerate": {
            "title": "Uitnodigingslink opnieuw genereren",
            "text": "Hier kun je de uitnodigingslink voor de klasruimte opnieuw genereren. Houd er rekening mee dat de oude link daarna ongeldig wordt.",
            "confirm": "Ja, opnieuw genereren"
          },
          "flash": {
            "generateFailure": "Uitnodigingslink kon niet worden aangemaakt.",
            "regenerateSuccess": "Uitnodigingslink is opnieuw gegenereerd.",
            "regenerateFailure": "Uitnodigingslink kon niet opnieuw worden gegenereerd."
          }
        }
      },
      "modals": {
        "deleteConfirmation": {
          "confirmButton": "Verwijderen",
          "projectsInfo": "alle actieve projecten (momenteel {count})",
          "subtitle": "Weet je zeker dat je de klasruimte {schoolClassName} wilt verwijderen?",
          "text": "De klasruimte wordt verwijderd voor alle deelnemende docenten.",
          "textWithProjects": "De klasruimte wordt verwijderd voor alle deelnemende docenten. Bovendien worden {projectsInfo} automatisch beëindigd.",
          "title": "Klasruimte verwijderen?"
        }
      },
      "project": {
        "create": "Nieuw project aanmaken",
        "defaults": {
          "descriptionPlaceholder": "Hier kun je jouw werkopdracht nader beschrijven.",
          "name": "Projectnaam",
          "projectNamePlaceholder": "Taaknaam invoeren..."
        },
        "heading": {
          "noProject": "Tijd voor een kleine pauze",
          "createFromTemplate": "AI Introductie voor Leerlingen"
        },
        "share": {
          "button": "Vrijgeven",
          "dialogTitle": "Deel dit project met jouw collega's",
          "dialogDescription": "Hier kun je docenten uit de klasruimte {schoolClassName} toevoegen aan het project {projectName}.",
          "dialogDescriptionNoClass": "Hier kun je docenten toevoegen aan het project {projectName}."
        },
        "errors": {
          "fileAttachFailed": "„{filename}“ kon niet worden toegevoegd aan het project. Controleer het bestandstype en de bestandsgrootte.",
          "fileRemoveFailed": "Het bestand kon niet worden verwijderd. Probeer het opnieuw.",
          "imageUpdateFailed": "De projectafbeelding kon niet worden opgeslagen. Probeer het opnieuw.",
          "itemLoadFailed": "Het te delen materiaal kon niet worden geladen. Je kunt het selecteren via 'Inhoud toevoegen'.",
          "itemUnlockFailed": "Het project is aangemaakt, maar de deeleinstellingen van het materiaal konden niet worden bijgewerkt. Controleer ze in het materiaal."
        },
        "hints": {
          "dropFile": "Sleep het bestand hierheen of selecteer een bestand.",
          "projectItemsLimitReached": "Je hebt het maximale aantal van 10 materialen bereikt. Verwijder materialen om nieuwe toe te voegen."
        },
        "labels": {
          "activeShort": "Actief voor",
          "chatFrom": "Chat van",
          "createdBy": "Van {name}",
          "dayLabel": "Dag | Dagen",
          "description": "Werkopdracht",
          "completed": "Afgerond",
          "discardedAt": "Project beëindigd",
          "enabledTools": "Vrijgegeven Tools",
          "members": "Docent toevoegen",
          "membersPlaceholder": "Selecteren...",
          "membersNoOptions": "Voeg eerst docenten toe aan de klasruimte",
          "membersAllAdded": "Alle docenten van de klasruimte zijn al toegevoegd",
          "membersTooltip": "Docenten die zijn uitgenodigd voor deze klasruimte kunnen hier aan het project worden toegevoegd.",
          "end": "Project beëindigen",
          "feedbackGiven": "Feedback gegeven",
          "files": "Bestanden",
          "history": "Geschiedenis en inleveringen",
          "replaceImage": "Afbeelding vervangen",
          "teachers": "Docenten",
          "restore": "Project herstellen",
          "hourLabel": "Uur",
          "noProject": "Er zijn momenteel geen taken voor jou.",
          "noArchivedProjects": "Nog geen beëindigde projecten aanwezig.",
          "on": "op",
          "pausedPupil": "Jouw docent kan het project weer activeren.",
          "projectItemResponseSubmissions": "{count} inlevering | {count} inleveringen",
          "projectActive": "Project actief",
          "projectActiveFor": "Project actief voor",
          "projectItems": "Materialen en Assistenten",
          "projectPaused": "Project gepauzeerd",
          "pausedShort": "Gepauzeerd",
          "projectPausedSentence": "Project is gepauzeerd.",
          "pupil": {
            "accessCode": "Toegangscode:",
            "deactivate": "Toegang deactiveren",
            "delete": "Toegang verwijderen",
            "downloadList": "Lijst weergeven",
            "reactivate": "Toegang opnieuw activeren",
            "regenerateToken": "Toegangscode opnieuw genereren"
          },
          "draftFrom": "Concept van",
          "submittedOn": "Ingeleverd op"
        },
        "links": {
          "new": "Project aanmaken",
          "newEmpty": "Leeg project",
          "newFromTemplate": "Project aanmaken op basis van sjabloon",
          "open": "Project openen",
          "remove": "Project verwijderen",
          "saveAsTemplate": "Opslaan als sjabloon"
        },
        "paragraphs": {
          "createTile": "Deel een werkopdracht en geef specifieke tools en materialen vrij.",
          "createFromTemplateTile": "Gebruik onze voorbereide introductiecursus om basiskennis over AI-competentie over te brengen.",
          "templateModalDescription": "Kies een sjabloon en ontvang een voorbereid project voor jouw klaslokaal.",
          "pupil": {
            "empty": "Er zijn nog geen deelnemers in deze klaslokaal. Deel de toegangslink om te beginnen."
          }
        },
        "picker": {
          "addButton": "Inhoud toevoegen",
          "assistantCatalog": {
            "empty": "Geen assistenten gevonden.",
            "errorLoading": "De assistenten konden niet worden geladen.",
            "tabLabel": "Assistentencatalogus"
          },
          "dialogTitle": "Inhoud toevoegen",
          "myContent": {
            "empty": "Geen inhoud gevonden.",
            "emptyFolder": "Deze map is leeg.",
            "errorLoading": "Je inhoud kon niet worden geladen.",
            "tabLabel": "Mijn Opslag"
          },
          "searchPlaceholder": "Inhoud doorzoeken..."
        },
        "pupil": {
          "enabledTools": "Gedeelde Tools",
          "warning": {
            "text": "{title} Je docent kan te allen tijde je huidige werkstatus bekijken.",
            "title": "Goed om te weten:"
          }
        },
        "shareAlertHeadline": "Toegang voor alle deelnemers:"
      },
      "projectTemplates": {
        "heading": "Projectsjablonen",
        "breadcrumb": "Projectsjablonen"
      },
      "consentModal": {
        "title": "Actieve gegevensbescherming",
        "bullet1": "Alle invoer en gesprekken worden door fobizz geanonimiseerd",
        "bullet2": "De gegevens worden niet gebruikt voor het trainen van AI-modellen",
        "bullet3": "Je docent kan te allen tijde je huidige werkstatus bekijken",
        "toggleLabel": "Ik ben me ervan bewust dat ik nooit persoonlijke gegevens met de AI mag delen en dat ik AI-antwoorden kritisch moet controleren.",
        "submitButton": "Klaslokaal gebruiken",
        "learnMoreLink": "Meer informatie over gegevensbescherming",
        "learnMoreUrl": "https://fobizz.com/de/datenschutz-bestimmungen/"
      },
      "inviteRedeem": {
        "title": "Uitnodiging voor klaslokaal {name}",
        "body": "{inviter} heeft je uitgenodigd voor het klaslokaal {name}.",
        "bodyNoInviter": "Je bent uitgenodigd voor het klaslokaal {name}.",
        "join": "Deelnemen aan klaslokaal",
        "decline": "Afwijzen",
        "invalidTitle": "Deze uitnodigingslink is niet langer geldig.",
        "invalidSubtitle": "Vraag het team om een nieuwe uitnodigingslink.",
        "expiredTitle": "De link is verlopen",
        "expiredSubtitle": "De persoon die het klaslokaal beheert, kan je de huidige link sturen.",
        "expiredConfirm": "OK",
        "errorTitle": "De uitnodiging kon niet worden geladen.",
        "errorSubtitle": "Controleer je verbinding en probeer het opnieuw.",
        "retry": "Opnieuw proberen",
        "backToOverview": "Naar 'Organiseren'",
        "licenseActivateTitle": "1/2 Licentiegroep activeren",
        "licenseActivateBody": "{inviter} heeft je uitgenodigd voor het klaslokaal {name}.{break}Voor het gebruik van de klaslokalen heb je een {license} nodig.",
        "licenseActivateBodyNoInviter": "Je bent uitgenodigd voor het klaslokaal {name}.{break}Voor het gebruik van de klaslokalen heb je een {license} nodig.",
        "licenseActivateDifferentSchoolBody": "{inviter} heeft je uitgenodigd voor het klaslokaal {name}.{break}Je actieve licentie behoort niet tot de school van het klaslokaal.",
        "licenseActivateDifferentSchoolBodyNoInviter": "Je bent uitgenodigd voor het klaslokaal {name}.{break}Je actieve licentie behoort niet tot de school van het klaslokaal.",
        "licenseCodeLabelForSchool": "Heb je een 8-cijferige activeringscode voor de licentiegroep {school}?",
        "licenseWrongSchoolTitle": "De door jou gebruikte activeringscode is geldig voor een andere licentiegroep.",
        "licenseWrongSchoolBody": "Voor de klaslokaaluitnodiging van {inviter} heb je de activeringscode voor de licentiegroep {school} nodig.",
        "licenseWrongSchoolBodyNoInviter": "Voor de klaslokaaluitnodiging heb je de activeringscode voor de licentiegroep {school} nodig.",
        "licenseWrongSchoolBodyNoSchool": "Voor de klaslokaaluitnodiging van {inviter} heb je de activeringscode voor de juiste licentiegroep nodig.",
        "licenseJoinTitle": "2/2 Deelnemen aan klaslokaal",
        "licenseJoinBody": "{inviter} heeft je uitgenodigd voor het klaslokaal {name}. Word nu lid van het klaslokaal om projecten te delen.",
        "licenseJoinBodyNoInviter": "Je bent uitgenodigd voor het klaslokaal {name}. Word nu lid van het klaslokaal om projecten te delen.",
        "licenseName": "fobizz Licentie",
        "licenseCodeLabel": "Heb je al een 8-cijferige activeringscode?",
        "activateLicense": "Licentie activeren",
        "moreAboutGroupLicense": "Meer over de groepslicentie",
        "groupLicenseUrl": "https://fobizz.com/de/angebote-fuer-schulen-und-gruppen/",
        "flash": {
          "joinSuccess": "Uitnodiging geaccepteerd – Welkom in het klaslokaal {name}",
          "joinFailure": "Deelname mislukt. Probeer het opnieuw.",
          "declined": "Klaslokaaluitnodiging is afgewezen.",
          "alreadyMember": "Je bent al lid van het klaslokaal {name}.",
          "differentSchool": "Deze code hoort bij een andere school. Deelname aan dit klaslokaal is daardoor niet mogelijk.",
          "licenseActivated": "Licentiegroep {group} succesvol geactiveerd."
        }
      }
    }
  }
}
